/** Props for {@link Card}. */
export interface CardProps {
  readonly children: React.ReactNode;
  /** Optional accessible label, when the card is a landmark region. */
  readonly ariaLabel?: string;
}

/**
 * A raised content container.
 *
 * @param props - Component props.
 * @returns The card element.
 */
export function Card({ children, ariaLabel }: CardProps): React.JSX.Element {
  return (
    <section className="gm-card" aria-label={ariaLabel}>
      {children}
    </section>
  );
}
